const state = {
    snackbar: false,
    snackbarColor: '',
    snackbarMessage: '',
};
const actions = {

    snackbarToggle(context, data) {
        context.commit('snackbarToggle', data);
    },

};
const mutations = {
    snackbarToggle(state, data) {
        state.snackbar = data.open;
        state.snackbarColor = data.color;
        state.snackbarMessage = data.message;
    },
};
export default {
    state,
    actions,
    mutations,

};